<template>
  <div v-if="video">
    <div class="frame-view__heading">
      <div style="display: flex;align-items: center">
        <div class="frame-view__btn" @click="goBackToFolder">
          <svgicon name="Chevron-left"></svgicon>
        </div>
        <div class="frame-view__title acr-ultra-bold">{{video.display_name || video.video_name}}</div>
      </div>
    </div>
    <div class="frame-view__wrapper min">
      <div class="frame-view min">
        <video
          class="min"
          style="width: 100%;height: calc(100vh - 269px);"
          :src="video.video_url || video.original_video_url"
          controls
          v-if="video && (video.video_url || video.original_video_url)"/>
        <div class="frame-view__nav">
          <div class="metadata">
            <div class="metadata-titles">
              <span class="acr-bold-18">Metadata</span>
              <span class="acr-bold" style="color: rgba(36, 49, 67, 0.6);">SIZE</span>
              <span class="acr-bold" style="color: rgba(36, 49, 67, 0.6);">FPS</span>
              <span class="acr-bold" style="color: rgba(36, 49, 67, 0.6);">WIDTH</span>
              <span class="acr-bold" style="color: rgba(36, 49, 67, 0.6);">HEIGHT</span>
              <span class="acr-bold" style="color: rgba(36, 49, 67, 0.6);min-width: 300px">HASH</span>
            </div>
            <div class="metadata-values">
              <span class="acr-bold-18"></span>
              <span >{{bytesToSize(video.video_size)}}</span>
              <span >{{video.video_fps}}</span>
              <span >{{video.video_width}}px</span>
              <span >{{video.video_height}}px</span>
              <span style="min-width: 300px">{{video.video_hash}}</span>
            </div>
          </div>
        </div>

      </div>
      <div class="filter detections" >
        <div>
          <div class="detections-title acr-bold-18">Video information</div>
          <div>
            <div class="edit-clip">
              <div class="edit-clip__field">
                <div class="edit-clip__label">Display name</div>
                <input label="Display name" v-model="selectedClipNewName" :readonly="!editMode">
              </div>
              <div class="edit-clip__field">
                <div class="edit-clip__label">Event name</div>
                <input label="Event name" v-model="selectedClipNewEventName" :readonly="!editMode">
              </div>
              <div class="edit-clip__field">
                <div class="edit-clip__label">Event place</div>
                <input label="Event place" v-model="selectedClipNewPlace" :readonly="!editMode">
              </div>
              <div class="edit-clip__field">
                <div class="edit-clip__label">Event date</div>
                <input label="Event date" type="date" v-model="selectedClipNewDate" :readonly="!editMode">
              </div>
              <div class="edit-clip__field">
                <div class="edit-clip__label">Description</div>
                <textarea v-model="selectedClipNewDescription" rows="4" :readonly="!editMode"></textarea>
              </div>
            </div>
          </div>
        </div>
        <div class="detections-btn" @click="updateVideo">{{editMode ? 'Save' : 'Edit'}}</div>
      </div>
    </div>

  </div>
</template>

<script>
  import {getVideoById, updateVideo, processVideo} from '../../api/files';
  import moment from 'moment';

  export default {
    name: "Video",
    data() {
      return {
        hideFilter: true,
        video: null,
        active: false,
        editClipDialog: false,
        editMode: false,
        selectedClipNewName: '',
        selectedClipNewDescription: '',
        selectedClipNewDate: '',
        selectedClipNewPlace: '',
        selectedClipNewEventName: '',
        showBackButton: false,
        vsLoadingInstance: null,
        timeout: false,
        process: 0,
      }
    },
    beforeRouteEnter(to, from, next) {
      if (from.name === 'dashboard') {
        next((vm) => {
          vm.showBackButton = true;
        })
      } else {
        next((vm) => {
          vm.showBackButton = false
        });
      }

    },
    created() {
      this.fetchVideo();
      this.$socket.on('video-status-update', (e, data) => {
        if (data.status === 100) {
          this.video.status = 'done';
        }
      })
    },
    beforeRouteLeave(to, from ,next) {
      if (this.vsLoadingInstance) this.vsLoadingInstance.close();
      if (this.timeout) clearTimeout(this.timeout);
      next();
    },
    methods: {
      reprocess() {
        this.vsLoadingInstance = this.$vs.loading({
          color: '#1e1e1e',
          target: document.getElementById('main'),
          percent: 0
        });
        processVideo(this.$route.params.videoId).then(() => this.$forceUpdate());
      },
      goBackToFolder() {
        this.$router.push({ name: 'dashboard', params: {folderId: this.video.parent_id}})
      },
      formatEventDate(date) {
        return moment(date).format('YYYY-MM-DD');
      },
      async fetchVideo() {
        return new Promise((resolve) => {
          getVideoById(this.$route.params.videoId).then((data) => {
            this.video = data.data;
            this.selectedClipNewName = this.video.display_name;
            this.selectedClipNewDescription = this.video.description;
            this.selectedClipNewDate = this.video.event_date ? this.formatEventDate(this.video.event_date) : '';
            this.selectedClipNewPlace = this.video.event_place;
            this.selectedClipNewEventName = this.video.event_name;
            if (this.vsLoadingInstance) this.vsLoadingInstance.close();
            resolve(this.video)
          });
        })
      },
      updateVideo() {
        if (!this.editMode) {
          this.editMode = true;
          return
        }

        const formData = new FormData();
        const payload = {
          ...(this.selectedClipNewName && { display_name: this.selectedClipNewName }),
          ...(this.selectedClipNewDescription && { description: this.selectedClipNewDescription }),
          ...(this.selectedClipNewDate && { event_date: this.selectedClipNewDate }),
          ...(this.selectedClipNewPlace && { event_place: this.selectedClipNewPlace }),
          ...(this.selectedClipNewEventName && { event_name: this.selectedClipNewEventName }),
        };

        if (Object.keys(payload).length === 0) return;

        Object.keys(payload).forEach(key => formData.append(key, payload[key]));

        updateVideo(formData, this.$route.params.videoId).then(() => {
          this.video = {...this.video, ...payload};
          this.fetchVideo();
          this.editMode = false;
        });
      },
      bytesToSize(bytes) {
        const sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB'];
        if (bytes == 0) return '0 Byte';
        const i = parseInt(Math.floor(Math.log(bytes) / Math.log(1024)));
        return Math.round(bytes / Math.pow(1024, i), 2) + ' ' + sizes[i];
      },
    },
  }
</script>

<style scoped lang="scss">
  /deep/
 .el-switch {
    &__label {
      font-size: 18px;
      font-family: 'AcronisCyberBold';
      color: rgba(36, 49, 67, 0.6);
      &.is-active {
        color: #00204D;
      }
    }
   &__core {
     min-width: 51px;
     height: 29px;
     border: none;
     border-radius: 20px;

     &::after {
       background: #9BC225;
       border: 0.5px solid rgba(0, 0, 0, 0.04);
       box-shadow: 0px 3px 8px rgba(0, 0, 0, 0.15);
       width: 25px;
       height: 25px;
     }
   }
 }

  /deep/

.el-switch.is-checked .el-switch__core::after {
    margin-left: -29px;
  }

  .edit-clip {
    width: 100%;
    margin-top: 13px;
    &__label {
      font-style: normal;
      font-weight: bold;
      font-size: 14px;
      line-height: 19px;
      margin-bottom: 6px;
      color: rgba(36, 49, 67, 0.6);
    }
    input, textarea {
      width: 100%;
      margin-bottom: 7px;
      border-radius: 3px;
    }
    textarea {
      min-height: 170px;
      resize: none;
    }
  }
</style>
